import _ from "lodash";
import * as d3 from 'd3'
export type Vec2 = [number, number]
export type Vec3 = [number, number, number]

export type T_WithSequnce<T> = T & { _sequence: number }

export function withSequence<T>(data: T[], start = 1) {
    return _.map(data, (item, idx) => {
        return {
            _sequence: idx + start,
            ...item,
        }
    })
}

/**
 * 矩阵转置 
 */
export function transpose<T>(arr: T[][]) {
    if (_.isEmpty(arr)) {
        return arr
    }
    const oldRows = arr.length
    const oldCols = arr[0].length
    const newRows = oldCols
    const newCols = oldRows
    const res = []
    for (let r = 0; r < newRows; r++) {
        let colArray = new Array(newCols)
        for (let c = 0; c < newCols; c++) {
            colArray[c] = arr[c][r]
        }
        res.push(colArray)
    }
    return res
}

export function toFixed(n, digits = 2) {
    let num = _.toNumber(n)
    if (!_.isFinite(num)) {
        return ''
    }
    let f = d3.format(`.${digits}f`)
    return f(num)
}


export function arrayWithFirstLast<T>(array: T[]) {
    const arrSize = _.size(array)
    return _.map(array, (item, idx) => {
        return {
            value: item,
            isFirst: idx === 0,
            isLast: idx === arrSize - 1
        }
    })
}

export function mapToPercents(data: number[]) {
    if (_.isEmpty(data)) {
        return []
    }
    const total = _.sum(data)
    if (total === 0) {
        return _.map(data, d => 0)
    }

    // 0 不参与百分比补差，避免末项为 0 时被分配舍入后的剩余百分比。
    const lastNonZeroIndex = _.findLastIndex(data, num => num !== 0)
    const percents = _.map(data, (num, index) => {
        if (num === 0 || index === lastNonZeroIndex) {
            return 0
        }
        return _.toInteger(num * 100 / total || 0)
    })
    percents[lastNonZeroIndex] = 100 - _.sum(percents)
    return percents
}

export function toPercent(num: number, total: number) {
    if (total == 0) {
        return 0
    }
    return Math.floor(num * 100 / total)
}

// theta_deg = atan(slopeThreshold) * (180/pi);

/**
 * 角度公式
 * 斜率 -> 角度
 */
export function slope2ThetaDeg(value: number) {
    return Math.atan(value) * (180 / Math.PI)
}

export function inRange(value, min, max) {
    if (value <= max && value >= min) {
        return true
    }
    return false
}

export function minmax(data: number[]) {
    let min = Infinity
    let max = -Infinity
    for (var i = 0; i < data.length; i++) {
        let value = data[i]
        max = Math.max(value, max)
        min = Math.min(value, min)
    }
    return [min, max]
}

export function linearMap(value, min, max, toMin, toMax) {
    let res = toMin + ((value - min) * (toMax - toMin)) / (max - min);
    return res;
}

export function forceToNumber(n) {
    if (_.isNil(n)) {
        return 0
    }
    return n
}

export function forceObjNumber<T>(obj: T): T {
    return _.mapValues(obj as any, val => {
        return forceToNumber(val)
    }) as T
}

export function forceObjFieldsNumber<T extends object>(obj: T, fields: (keyof T)[]): T {
    return _.mapValues(obj, (value, key) => {
        if (_.includes(fields, key as any)) {
            return forceToNumber(value)
        } else {
            return value
        }
    }) as T
}
